// extracted by mini-css-extract-plugin
export default {"mainContainer":"main-container__main-container__h81T2","formPanel":"main-container__form-panel__qrZJj"};